import { render, staticRenderFns } from "./TermsAndServicesModal.vue?vue&type=template&id=59f030f0&"
import script from "./TermsAndServicesModal.vue?vue&type=script&lang=js&"
export * from "./TermsAndServicesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports